<template>
	<div>
		<div :class="{[$style.air__sidebar]: true, [$style.air__sidebar__toggled]: settings.isSidebarOpen}">
			<div :style="{ height: '100%', 'overflow-y': 'auto' }">
				<div :class="$style.air__sidebar__inner">
					<a href="javascript: void(0);" :class="$style.air__sidebar__close" @click="toggleSidebar()"><fa-icon :icon="['far','times']" /></a>
					<h5>
						<strong>Configuración</strong>
					</h5>
					<div class="air__utils__line" :style="{ marginTop: '25px', marginBottom: '30px' }" />
					<p class="text-muted mb-5">
						Personaliza el panel a tu gusto. Posición, transiciones, colores, tamaños...
					</p>
					<div :class="$style.air__sidebar__type">
						<div :class="$style.air__sidebar__type__title">
							<span>Tamaño de inputs</span>
						</div>
						<div :class="$style.air__sidebar__type__items">
							<div :class="$style.air__sidebar__container">
								<a-select :default-value="settings.inputSize" style="width: 100%;" @change="selectInputSize">
									<a-select-option value="large">
										Grande
									</a-select-option>
									<a-select-option value="default">
										Estandar
									</a-select-option>
									<a-select-option value="small">
										Pequeño
									</a-select-option>
								</a-select>
							</div>
						</div>
					</div>
					<div :class="$style.air__sidebar__type">
						<div :class="$style.air__sidebar__type__title">
							<span>Notificaciones de audio</span>
						</div>
						<div :class="$style.air__sidebar__type__items">
							<div :class="$style.air__sidebar__container">
								<a-select :default-value="settings.audio" style="width: 100%;" @change="selectNotificationAudio">
									<a-select-option value="">
										Ninguno
									</a-select-option>
									<a-select-option value="popup.mp3">
										Popup
									</a-select-option>
									<a-select-option value="bubbles.mp3">
										Burbuja
									</a-select-option>
									<a-select-option value="siliconValley.mp3">
										Silicon Valley
									</a-select-option>
									<a-select-option value="castor.mp3">
										Castor
									</a-select-option>
								</a-select>
							</div>
						</div>
					</div>
					<div :class="$style.air__sidebar__type">
						<div :class="$style.air__sidebar__type__title">
							<span>Menu lateral</span>
						</div>
						<div :class="[$style.air__sidebar__type__items,'mb-4']">
							<a-radio-group :default-value="settings.menuLayoutType" @change="selectMenuLayoutType">
								<div class="row">
									<div class="col-6">
										<div class="mb-2">
											<a-radio :value="'left'">
												Izquierda
											</a-radio>
										</div>
										<div class="mb-2">
											<a-radio :value="'nomenu'">
												Oculto
											</a-radio>
										</div>
									</div>
									<div class="col-6">
										<div class="mb-2">
											<a-radio :value="'top'">
												Arriba
											</a-radio>
										</div>
									</div>
								</div>
							</a-radio-group>
						</div>
						<div :class="$style.air__sidebar__item">
							<div :class="$style.air__sidebar__label">
								Modo compacto
							</div>
							<div :class="$style.air__sidebar__container">
								<a-switch :checked="settings.isMenuCollapsed" @click="settingChange($event, 'isMenuCollapsed')" />
							</div>
						</div>
						<div :class="$style.air__sidebar__item">
							<div :class="$style.air__sidebar__label">
								Fijar menu
							</div>
							<div :class="$style.air__sidebar__container">
								<a-switch :checked="!settings.isMenuUnfixed" @click="settingChange($event, 'isMenuUnfixed')" />
							</div>
						</div>
						<div :class="$style.air__sidebar__item">
							<div :class="$style.air__sidebar__label">
								Color de menu
							</div>
							<div :class="$style.air__sidebar__container">
								<air-color-picker :value="settings.menuColor" :setting="'menuColor'" :colors="['white', 'gray', 'blue', 'dark']" />
							</div>
						</div>
					</div>
					<div :class="$style.air__sidebar__type">
						<div :class="$style.air__sidebar__type__title">
							<span>Submenus laterales</span>
						</div>
						<div :class="[$style.air__sidebar__type__items,'mb-4']">
							<a-radio-group :default-value="settings.menuType" @change="selectMenuType">
								<div class="row">
									<div class="col-6">
										<div class="mb-2">
											<a-radio :value="'default'" :disabled="settings.menuLayoutType !== 'left'">
												Estandar
											</a-radio>
										</div>
										<div class="mb-2">
											<a-radio :value="'flyout'" :disabled="settings.menuLayoutType !== 'left'">
												Flyout
											</a-radio>
										</div>
									</div>
									<div class="col-6">
										<div class="mb-2">
											<a-radio :value="'compact'" :disabled="settings.menuLayoutType !== 'left'">
												Compacto
											</a-radio>
										</div>
									</div>
								</div>
							</a-radio-group>
						</div>
						<div :class="$style.air__sidebar__item">
							<div :class="$style.air__sidebar__label">
								Color
							</div>
							<div :class="$style.air__sidebar__container">
								<air-color-picker :value="settings.flyoutMenuColor" :setting="'flyoutMenuColor'" :colors="['white', 'gray', 'blue', 'dark']" />
							</div>
						</div>
					</div>
					<div :class="$style.air__sidebar__type" class="mb-4">
						<div :class="$style.air__sidebar__type__title">
							<span>Transición entre ventanas</span>
						</div>
						<div :class="$style.air__sidebar__type__items">
							<a-select :default-value="settings.routerAnimation" style="width: 100%;" @change="selectRouterAnimation">
								<a-select-option value="none">
									None
								</a-select-option>
								<a-select-option value="slide-fadein-up">
									Deslizar hacia arriba
								</a-select-option>
								<a-select-option value="slide-fadein-right">
									Deslizar a la derecha
								</a-select-option>
								<a-select-option value="fadein">
									Desvanecer
								</a-select-option>
								<a-select-option value="zoom-fadein">
									Zoom
								</a-select-option>
							</a-select>
						</div>
					</div>

					<div :class="$style.air__sidebar__type" class="mb-4">
						<div :class="$style.air__sidebar__type__title">
							<span>Personalización</span>
						</div>

						<div :class="$style.air__sidebar__type__items">
							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Fondo gris
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch :checked="settings.isGrayBackground" @click="settingChange($event, 'isGrayBackground')" />
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Topbar gris
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch :checked="settings.isGrayTopbar" @click="settingChange($event, 'isGrayTopbar')" />
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Renderizar sombras
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch :checked="settings.isCardShadow" @click="settingChange($event, 'isCardShadow')" />
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Bordes cuadrados
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch :checked="settings.isSquaredBorders" @click="settingChange($event, 'isSquaredBorders')" />
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Bordes en contenido
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch :checked="!settings.isBorderless" @click="settingChange($event, 'isBorderless')" />
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Sombras en menú
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch
										:checked="settings.isMenuShadow"
										@click="settingChange($event, 'isMenuShadow')"
									/>
								</div>
							</div>
						</div>
					</div>

					<div :class="$style.air__sidebar__type" class="mb-4">
						<div :class="$style.air__sidebar__type__title">
							<span>Otros</span>
						</div>

						<div :class="$style.air__sidebar__type__items">
							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Fijar Topbar
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch :checked="settings.isTopbarFixed" @click="settingChange($event, 'isTopbarFixed')" />
								</div>
							</div>

							<!-- <div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Login color
								</div>
								<div :class="$style.air__sidebar__container">
									<air-color-picker :value="settings.systemLayoutColor" :setting="'systemLayoutColor'" :colors="['white', 'gray', 'blue', 'dark', 'image']"/>
								</div>
							</div> -->

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Extender contenido
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch :checked="settings.isContentNoMaxWidth" @click="settingChange($event, 'isContentNoMaxWidth')" />
								</div>
							</div>

							<div :class="$style.air__sidebar__item">
								<div :class="$style.air__sidebar__label">
									Compactar contenido
								</div>
								<div :class="$style.air__sidebar__container">
									<a-switch :checked="settings.isAppMaxWidth" @click="settingChange($event, 'isAppMaxWidth')" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import AirColorPicker from '@/components/layout/Sidebar/partials/colorPicker';

export default {
	components: { AirColorPicker },
	computed: mapState(['settings']),
	methods: {
		toggleSidebar() {
			const setting = 'isSidebarOpen';
			const value = !this.settings[setting];
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		settingChange(e, setting) {
			const value = !this.settings[setting];
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		selectMenuType(e) {
			const setting = 'menuType';
			const { value } = e.target;
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		selectMenuLayoutType(e) {
			const setting = 'menuLayoutType';
			const { value } = e.target;
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		selectRouterAnimation(value) {
			const setting = 'routerAnimation';
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		selectInputSize(value) {
			const setting = 'inputSize';
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
		selectNotificationAudio(value) {
			const setting = 'audio';
			if (value) {
				// eslint-disable-next-line import/no-dynamic-require
				const audio = new Audio(require(`@/assets/sounds/${value}`));
				audio.play();
			}
			this.$store.commit('CHANGE_SETTING', { setting, value });
		},
	},
};
</script>

<style lang="scss" module>
@import "./style.module.scss";
</style>
